import { action } from 'typesafe-actions';
export const enum ModalActionTypes {
  SHOW_MODAL = '@@modal/SHOW_MODAL',
  CLOSE_MODAL = '@@modal/CLOSE_MODAL',
}

export const showModal = () => action(ModalActionTypes.SHOW_MODAL);

export const closeModal = () => action(ModalActionTypes.CLOSE_MODAL);
